Vue.use(VueRouter)
import Vue from 'vue'
import VueRouter from 'vue-router'
const home = () => import('../views/home/index')
const homeIndex = () => import('../views/new/homeIndex')
const salesPrefecture = () => import('../views/new/salesPrefecture')
const brandZone = () => import('../views/new/brandZone')
const setMeal = () => import('../views/new/setMeal')
const classFly = () => import('../views/new/classFly')
const dynamic = () => import('../views/home/dynamic')
const homeTem = () => import('../views/home/home-tem')
const my = () => import('../views/home/my')
const website = () => import('../views/home/website')
const social = () => import('../views/home/social')
const shopList = () => import('../views/shopList')
const shopDetails = () => import('../views/shopDetails')
const wallet = () => import('../views/wallet')
const withdrawal = () => import('../views/withdrawal')
const myOrder = () => import('../views/myOrder')
const realName = () => import('../views/realName')
const bindingBank = () => import('../views/bindingBank')
const cityList = () => import('../views/cityList')
const addCity = () => import('../views/addCity')
const giftBig = () => import('../views/giftBig')
const shopIntegral = () => import('../views/shopIntegral')
const cashierDesk = () => import('../views/cashierDesk')
const share = () => import('../views/share')
const register = () => import('../views/register')
const deliveryDetails = () => import('../views/deliveryDetails') //提货明细
const giftGoodsList = () => import('../views/giftGoodsList') //提货专区列表
const giftGoodsCont = () => import('../views/giftGoodsCont') //提货专区内容
const orderDetails = () => import('../views/orderDetails') //订单详情
const giftGoodsBeer = () => import('../views/giftGoodsBeer') //啤酒提货专区
const dynamicDetails = () => import('../views/dynamicDetails') //动态详情
const orderShipInfo = () => import('../views/orderShipInfo') //物流详情-订单跟踪
const delivery = () => import('../views/delivery') //提货礼包
const storeMessage = () => import('../views/storeMessage')
const storeDetail = () => import('../views/storeDetail')
const businessList = () => import('../views/businessList')
const activeShopDetail = () => import('../views/activeShopDetail')
const rankShopDetail = () => import('../views/activity/rankShopDetail')
const realNameDetail = () => import('../views/realNameDetail')
const expressage = () => import('../views/aftermarket/expressage')
const rule = () => import('../views/rule')
const ruleList = () => import('../views/ruleList')
const invoiceManager = () => import('../views/invoice/invoiceManager') //发票管理
const invoiceDetails = () => import('../views/invoice/invoiceDetails') //发票详情
const invoiceMachine = () => import('../views/invoice/invoiceMachine') //发票详情
const geographical = () => import('../views/geographical') //地图
const redemption = () => import('../views/activity/redemption') //一元购
const Member = () => import('../views/Member') //一元购
const memberDetail = () => import('../views/memberDetail') //一元购
const refresh = () => import('../views/refresh') //一元购
const fansList = () => import('../views/fansList') //一元购
const fansDetail = () => import('../views/fansDetail') //一元购
//红包专区
const redList = () => import('../views/redPacket/redList') //一元购
const redDetails = () => import('../views/redPacket/redDetails')
const shopingAugment = () => import('../views/redPacket/shopingAugment')
const discount = () => import('../views/redPacket/discount')
const leading = () => import('../views/redPacket/leading')
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeIndex',
    component: homeTem,
    children: [
      {
        path: 'homeIndex',
        component: homeIndex,
        meta: {
          title: '壹玖叮咚',
          keepAlive: true
        }
      },
      {
        path: '/social',
        component: social,
        meta: {
          title: '社交'
        }
      },
      {
        path: 'website',
        component: website,
        meta: {
          title: '官网'
        }
      },
      {
        path: 'dynamic',
        component: dynamic,
        meta: {
          title: '动态'
        }
      },
      {
        path: 'my',
        component: my,
        meta: {
          title: '我的'
        }
      },

      {
        path: '/',
        redirect: '/homeIndex'
      }
    ]
  },
  {
    path: '/home',
    component: home,
    meta: {
      title: '壹玖叮咚'
    }
  },
  {
    path: '/businessList',
    component: businessList,
    meta: {
      title: '社交'
    }
  },
  {
    path: '/fansList',
    component: fansList,
    meta: {
      title: '粉丝'
    }
  },
  {
    path: '/fansDetail',
    component: fansDetail,
    meta: {
      title: '会员'
    }
  },
  {
    path: '/shopList',
    component: shopList,
    meta: {
      title: '特价专区'
    }
  },
  {
    path: '/salesPrefecture',
    component: salesPrefecture,
    meta: {
      title: '买赠专区'
    }
  },
  {
    path: '/brandZone',
    component: brandZone,
    meta: {
      title: '品牌专区'
    }
  },
  {
    path: '/setMeal',
    component: setMeal,
    meta: {
      title: '套餐专区'
    }
  },
  {
    path: '/classFly',
    component: classFly,
    meta: {
      title: '搜索'
    }
  },
  {
    path: '/redList',
    component: redList,
    meta: {
      title: '红包列表'
    }
  },
  {
    path: '/redDetails',
    component: redDetails,
    meta: {
      title: '红包使用详情'
    }
  },
  {
    path: '/leading',
    component: leading,
    meta: {
      title: '领取红包'
    }
  },
  {
    path: '/shopingAugment',
    component: shopingAugment,
    meta: {
      title: '我的购物券 '
    }
  },
  {
    path: '/discount',
    component: discount,
    meta: {
      title: '抵扣专区 '
    }
  },
  {
    path: '/refresh',
    component: refresh,
    meta: {
      title: ''
    }
  },
  {
    path: '/Member',
    component: Member,
    meta: {
      title: '会员'
    }
  },
  {
    path: '/activeShopDetail',
    component: activeShopDetail,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/rankShopDetail',
    component: rankShopDetail,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/redemption',
    component: redemption,
    meta: {
      title: ''
    }
  },
  {
    path: '/geographical',
    component: geographical,
    meta: {
      title: '导航'
    }
  },
  {
    path: '/memberDetail',
    component: memberDetail,
    meta: {
      title: '会员详情'
    }
  },
  {
    path: '/invoiceManager',
    component: invoiceManager,
    meta: {
      title: ''
    }
  },
  {
    path: '/invoiceDetails',
    component: invoiceDetails,
    meta: {
      title: ''
    }
  },
  {
    path: '/invoiceMachine',
    component: invoiceMachine,
    meta: {
      title: ''
    }
  },
  {
    path: '/expressage',
    component: expressage,
    meta: {
      title: '填写物流信息'
    }
  },
  {
    path: '/rule',
    component: rule,
    meta: {
      title: ''
    }
  },
  {
    path: '/ruleList',
    component: ruleList,
    meta: {
      title: ''
    }
  },
  {
    path: '/realNameDetail',
    component: realNameDetail,
    meta: {
      title: '实名认证'
    }
  },

  {
    path: '/delivery',
    component: delivery,
    meta: {
      title: '我的提货卡'
    }
  },
  {
    path: '/shopDetails',
    component: shopDetails,
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/wallet',
    component: wallet,
    meta: {
      title: '我的钱包'
    }
  },
  {
    path: '/withdrawal',
    component: withdrawal,
    meta: {
      title: '提现页'
    }
  },
  {
    path: '/myOrder',
    component: myOrder,
    meta: {
      title: '我的订单',
      keepAlive: true,
      scrollTop: 0
    }
  },
  {
    path: '/realName',
    component: realName,
    meta: {
      title: '实名认证'
    }
  },
  {
    path: '/giftBig',
    component: giftBig,
    meta: {
      title: '礼包中心',
      keepAlive: true
    }
  },
  {
    path: '/shopIntegral',
    component: shopIntegral,
    meta: {
      title: '购物积分'
    }
  },
  {
    path: '/cashierDesk',
    component: cashierDesk,
    meta: {
      title: '收银台'
    }
  },
  {
    path: '/cityList',
    component: cityList,
    meta: {
      title: '地址列表'
    }
  },

  {
    path: '/addCity',
    component: addCity,
    meta: {
      title: '新增收货地址'
    }
  },
  {
    path: '/register',
    component: () => import('../views/register.vue'), // 确认订单
    meta: {
      title: '注册'
    }
  },
  {
    path: '/ConfirmOrder',
    component: () => import('../views/ConfirmOrder/ConfirmOrder.vue'), // 确认订单
    meta: {
      title: '确认订单'
    }
  },
  {
    path: '/login',
    component: () => import('../views/login/login.vue'), // 登录
    meta: {
      title: '登录'
    }
  },
  {
    path: '/share',
    component: share,
    meta: {
      title: '分享商品'
    }
  },
  {
    path: '/shoppingCart',
    component: () => import('../views/shoppingCart/shoppingCart'),
    meta: {
      title: '购物车'
    }
  },
  {
    path: '/deliveryDetails',
    component: () => import('../views/deliveryDetails'),
    meta: {
      title: '提货明细'
    }
  },
  {
    path: '/orderDetails',
    component: () => import('../views/orderDetails'),
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/aftermarketList',
    component: () => import('../views/aftermarket/aftermarketList'),
    meta: {
      title: '售后列表'
    }
  },
  {
    path: '/selectType',
    name: 'selectType',
    component: () => import('../views/aftermarket/selectType.vue'), //选择售后类型
    meta: {
      title: '选择售后类型'
    }
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/aftermarket/details.vue'), //售后详情
    meta: {
      title: '售后详情'
    }
  },
  {
    path: '/returnGoodsForm',
    name: 'returnGoodsForm', //退货表单 创建退换货
    component: () => import('../views/aftermarket/returnGoodsForm.vue'), //售后列表
    meta: {
      title: '售后'
    }
  },
  {
    path: '/giftGoodsList',
    component: giftGoodsList,
    meta: {
      title: '提货专区列表'
    }
  },
  {
    path: '/giftGoodsCont',
    component: giftGoodsCont,
    meta: {
      title: '提货专区',
      scrollTop: 0
    }
  },
  {
    path: '/bindingBank',
    component: bindingBank,
    meta: {
      title: '绑定银行卡'
    }
  },
  {
    path: '/giftGoodsBeer',
    component: giftGoodsBeer,
    meta: {
      title: '啤酒提货专区'
    }
  },
  {
    path: '/storeMessage',
    component: storeMessage,
    meta: {
      title: '店铺信息'
    }
  },
  {
    path: '/storeDetail',
    component: storeDetail,
    meta: {
      title: '店铺信息'
    }
  },
  {
    path: '/setup',
    component: () => import('../views/setup.vue'), //设置,
    meta: {
      title: '设置'
    }
  },
  {
    path: '/dynamicDetails',
    component: () => import('../views/dynamicDetails.vue'), //动态详情,
    meta: {
      title: '动态详情'
    }
  },
  {
    path: '/orderShipInfo',
    component: () => import('../views/orderShipInfo.vue'), //物流详情 -订单跟踪
    meta: {
      title: '订单跟踪'
    }
  },
  {
    path: '/successOrder',
    component: () => import('../views/successOrder.vue'), //物流详情 -订单跟踪
    meta: {
      title: ''
    }
  },
  {
    path: '/liveList',
    component: () => import('../views/liveList.vue'),
    meta: {
      title: '回放列表'
    }
  },
  {
    path: '/liveModel',
    component: () => import('../views/liveModel.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/live',
    component: () => import('../views/live.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/liveReport',
    component: () => import('../views/liveReport.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/activityIndex',
    component: () => import('../views/activity/activityIndex.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/example',
    component: () => import('../views/activity/example.vue'),
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/moped',
    component: () => import('../views/activity/moped.vue'),
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/hairRing',
    component: () => import('../views/hairRing.vue'),
    meta: {
      title: '发圈'
    }
  },
  {
    path: '/evaluateDetail',
    component: () => import('../views/evaluate/evaluateDetail.vue'),
    meta: {
      title: '评价详情'
    }
  },
  {
    path: '/evaluateEdit',
    component: () => import('../views/evaluate/evaluateEdit.vue'),
    meta: {
      title: '新建评价'
    }
  },
  {
    path: '/evaluateList',
    component: () => import('../views/evaluate/evaluateList.vue'),
    meta: {
      title: '评价列表'
    }
  },
  {
    path: '/evaluateGoods',
    component: () => import('../views/evaluate/evaluateGoods.vue'),
    meta: {
      title: '商品评价'
    }
  },
  {
    path: '/mtactivityIndex',
    component: () => import('../views/activity/mtactivityIndex.vue'),
    meta: {
      title: '茅台活动'
    }
  },
  {
    path: '/buyActiveShopdetails',
    component: () => import('../views/buyActiveShopdetails.vue'),
    meta: {
      title: '茅台活动'
    }
  },

  {
    path: '/realTimeDetail',
    component: () => import('../views/realTimeDetail.vue'),
    meta: {
      title: '资讯'
    }
  },

  {
    path: '*',
    redirect: '/homeIndex'
  }
]

const router = new VueRouter({
  routes,

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
